// src/utils/api-helpers/AuthService.helpers.ts
// NOT auto-generated — survives yarn generate:api

import { OpenAPI } from '../../api/core/OpenAPI';
import { request as __request } from '../../api/core/request';

export interface AuthPublicConfig {
  maxLoginAttempts: number;
  idleTimeoutMinutes: number;
}

const DEFAULT_PUBLIC_CONFIG: AuthPublicConfig = {
  maxLoginAttempts: 6,
  idleTimeoutMinutes: 30,
};

function normalizePublicConfig(raw: unknown): AuthPublicConfig {
  if (raw == null || typeof raw !== 'object') {
    return { ...DEFAULT_PUBLIC_CONFIG };
  }

  const body = raw as Partial<AuthPublicConfig>;
  const maxLoginAttempts = Number(body.maxLoginAttempts);
  const idleTimeoutMinutes = Number(body.idleTimeoutMinutes);

  return {
    maxLoginAttempts:
      Number.isFinite(maxLoginAttempts) && maxLoginAttempts > 0
        ? maxLoginAttempts
        : DEFAULT_PUBLIC_CONFIG.maxLoginAttempts,
    idleTimeoutMinutes:
      Number.isFinite(idleTimeoutMinutes) && idleTimeoutMinutes > 0
        ? idleTimeoutMinutes
        : DEFAULT_PUBLIC_CONFIG.idleTimeoutMinutes,
  };
}

export class AuthServiceHelpers {
  public static async getPublicConfig(): Promise<AuthPublicConfig> {
    const response = await __request(OpenAPI, {
      method: 'GET',
      url: '/auth/public-config',
    });
    return normalizePublicConfig(response);
  }

  public static getDefaultPublicConfig(): AuthPublicConfig {
    return { ...DEFAULT_PUBLIC_CONFIG };
  }
}
